import React, { useState, useEffect } from 'react';
import {object, func, bool, string} from 'prop-types';

import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import {CloneObject} from '../../../utils/helpers';
import {isEmptyString} from '../../../utils/validator';
import DatePickerCustom from '../../common/DatePickerCustom';
import InputEntidad from '../../common/InputEntidad';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import InputNumber from '../../common/InputNumber';
import Modal from '../../common/Modal';
import {TIPS} from "../../../consts/tips";
import {Accordion, FormError, FormLabel} from '../../common';

const LadoTerrenoObraModal = (props) => {

    const entityInit = {
        id: 0,
        idLadoTerreno: 0,
        idObra: 0,
        importe: 0,
        reduccionMetros: 0,
        reduccionSuperficie: 0,
        fecha: null,
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            idObra: props.data.entity.idObra,
            importe: props.data.entity.importe,
            reduccionMetros: props.data.entity.reduccionMetros,
            reduccionSuperficie: props.data.entity.reduccionSuperficie,
            fecha: props.data.entity.fecha
        })
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idObra: 0,
        importe: 0,
        reduccionMetros: 0,
        reduccionSuperficie: 0,
        fecha: null,
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.idObra = parseInt(formValues.idObra);
        row.importe = formValues.importe;
        row.reduccionMetros = formValues.reduccionMetros;
        row.reduccionSuperficie = formValues.reduccionSuperficie;
        row.fecha = formValues.fecha;

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idObra <= 0) errors.idObra = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.fecha === null) errors.fecha = VALIDATION_MESSAGE.REQUIRED_DATE;

        return errors;
    }

    return (
        <>

            <Modal
                size="lg"
                title="Obra del lado del terreno"
                tipName={TIPS.NAME.MODALS.LADO_TERRENO_OBRA_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Detalle" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-8">
                                                <FormLabel htmlFor="idObra" required>Obra</FormLabel>
                                                <InputEntidad
                                                    name="idObra"
                                                    placeholder=""
                                                    tipName={TIPS.NAME.MODALS.OBRA_MODAL}
                                                    className={`form-control ${errorOf('idObra') ? 'is-invalid' : ''}`}
                                                    value={formValues.idObra}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Obra"
                                                    entidad="Obra"
                                                    onFormat={(row) => (row) ? row.nombre : ''}
                                                    columns={[
                                                        {Header: 'Código', accessor: 'codigo', width: '25%'},
                                                        {Header: 'Nombre', accessor: 'nombre', width: '55%'},
                                                        {Header: 'Importe', accessor: 'importe', width: '15%'}
                                                    ]}
                                                />
                                                <FormError message={errorOf('idObra')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-4">
                                                <label htmlFor="importe" className="form-label">Importe</label>
                                                <InputNumber
                                                    name="importe"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.importe}
                                                    precision={2}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-md-4">
                                                <label htmlFor="reduccionMetros" className="form-label">Reducción de
                                                    metros</label>
                                                <InputNumber
                                                    name="reduccionMetros"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.reduccionMetros}
                                                    precision={2}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-md-4">
                                                <label htmlFor="reduccionSuperficie" className="form-label">Reducción
                                                    de superficie</label>
                                                <InputNumber
                                                    name="reduccionSuperficie"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.reduccionSuperficie}
                                                    precision={2}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-md-4">
                                                <FormLabel htmlFor="fecha" required>Fecha</FormLabel>
                                                <DatePickerCustom
                                                    name="fecha"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fecha') ? 'is-invalid' : ''}`}
                                                    value={formValues.fecha}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fecha')} />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de Obra de Lado del Terreno"
                                            processKey={props.processKey}
                                            entidad="LadoTerrenoObra"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

LadoTerrenoObraModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

LadoTerrenoObraModal.defaultProps = {
    disabled: false
};

export default LadoTerrenoObraModal;